'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BorrowingHistoryIcon = require('./BorrowingHistoryIcon');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BorrowingHistoryIcon).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/BorrowingHistoryIcon/index.js
// module id = 1122
// module chunks = 1